import { IExportData } from "@/pages/export-list/types";
import { getTranslateNsT } from "@/utils/getTranslateNsT";
import { dateFormatter } from "project-config/utils/date-formatter";
import { DotStatus } from "@/components/dot-status";
import { ColumnType } from "antd/es/table/interface";
import { Operations } from "@/pages/consumption/view/billing/components/operations";

export const getTableColumns: () => ColumnType<IExportData>[] = () => {
  const t = getTranslateNsT("consumption");

  return [
    {
      title: t("consumption_time_selector"),
      dataIndex: "consumeDate",
    },
    {
      title: t("consumption_label_bill_no"),
      dataIndex: "billNo",
    },
    {
      title: t("consumption_label_bill_appeal_no"),
      dataIndex: "appealBillNo",
      render: (row) => row || "-",
    },
    {
      title: t("user_operate_record_user_name"),
      dataIndex: "userName",
    },
    {
      title: t("consumption_table_header_company"),
      dataIndex: "company",
    },
    {
      title: t("user_accessKey_create_time"),
      dataIndex: "createTime",
      render: (v) => dateFormatter(v),
    },
    {
      title: t("consumption_label_pay_status"),
      dataIndex: "payStatus",
      render: (v: string) => (
        <DotStatus
          text={t(`consumption_pay_status_${v}`)}
          color={
            {
              0: "#FF4444",
              1: "#13CB75",
            }[v]
          }
        />
      ),
    },
    {
      title: t("consumption_label_confirm_status"),
      dataIndex: "confirmStatus",
      render: (v: string) => (
        <DotStatus
          text={t(`bill_confirm_status_${v}`)}
          color={
            {
              0: "#FF4444",
              1: "#13CB75",
              2: "#13CB75",
            }[v]
          }
        />
      ),
    },
    {
      title: t("consumption_bill_appeal_status"),
      dataIndex: "appealStatus",
      render: (v) =>
        typeof v === "number"
          ? t(`consumption_bill_appeal_status_${v + 1}`)
          : "-",
      filters: [
        {
          text: t("consumption_bill_appeal_status_1"),
          value: 0,
        },
        {
          text: t("consumption_bill_appeal_status_2"),
          value: 1,
        },
        {
          text: t("consumption_bill_appeal_status_3"),
          value: 2,
        },
        {
          text: t("consumption_bill_appeal_status_4"),
          value: 3,
        },
        {
          text: t("consumption_bill_appeal_status_5"),
          value: 4,
        },
      ],
      onFilter: () => true,
    },
    {
      title: t("operation"),
      render: (v, record) => <Operations record={record} />,
    },
  ];
};
